import { Reducer } from 'redux';
import { INITIAL_EXTRACTION_LIST_STATE } from '../../constants';
import {
    EXTRACTION_LIST_ERROR,
    EXTRACTION_LIST_FILTER_CHANGE,
    EXTRACTION_LIST_GET,
    EXTRACTION_LIST_LOADED,
    EXTRACTION_LIST_PAGE_CHANGE,
    EXTRACTION_LIST_SORT_CHANGE,
    ExtractionListActions,
} from '../actions/extractionListActions';
import { ExtractionListState } from '../types';

export const extractionListReducer: Reducer<ExtractionListState, ExtractionListActions> = (
    state = INITIAL_EXTRACTION_LIST_STATE,
    action
): ExtractionListState => {
    switch (action.type) {
        case EXTRACTION_LIST_GET:
            return {
                ...state,
                extractionData: { status: 'Loading', error: undefined, value: undefined },
            };
        case EXTRACTION_LIST_LOADED:
            return {
                ...state,
                totalRecords: action.payload.totalResults,
                extractionData: { status: 'Loaded', error: undefined, value: action.payload.extractions },
            };
        case EXTRACTION_LIST_ERROR:
            return {
                ...state,
                extractionData: { status: 'Failed', error: action.payload.error, value: undefined },
            };
        case EXTRACTION_LIST_PAGE_CHANGE:
            return {
                ...state,
                currentPage: action.payload.currentPage,
                startAt: action.payload.startAt,
                extractionData: { status: 'Uninitialized', error: undefined, value: undefined },
            };
        case EXTRACTION_LIST_SORT_CHANGE:
            return {
                ...state,
                currentPage: 1,
                startAt: 0,
                sortColumn: action.payload.sortColumn,
                sortDirection: action.payload.sortDirection,
                extractionData: { status: 'Uninitialized', error: undefined, value: undefined },
            };
        case EXTRACTION_LIST_FILTER_CHANGE:
            return {
                ...state,
                currentPage: 1,
                startAt: 0,
                statusFilter: action.payload.statusFilter ?? state.statusFilter,
                dateRange: action.payload.dateRange ?? state.dateRange,
                query: action.payload.query ?? state.query,
                searchBy: action.payload.searchBy ?? state.searchBy,
                extractionData: { status: 'Uninitialized', error: undefined, value: undefined },
            };
        default:
            return state;
    }
};
